export default {
  placeholder: 'Search',
}
